document.addEventListener('DOMContentLoaded', function() {
  initializeShowMoreFilters();
});

function initializeShowMoreFilters() {
  const filterListValues = document.querySelectorAll('.filter-list');
  
  filterListValues.forEach(function(filterContainer) {
    const showMoreFilters = filterContainer.parentElement.querySelector('.show-more-filters-button');
    const filterListItems = filterContainer.querySelectorAll('.filter-list-item');
    
    if (showMoreFilters && !showMoreFilters.hasAttribute('data-initialized')) {
      showMoreFilters.setAttribute('data-initialized', 'true');
      
      showMoreFilters.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        filterListItems.forEach(function(item) {
          item.classList.remove('hidden-option');
        });
      });
    }
  });
}

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('show-more-filters-button')) {
    event.preventDefault();
    event.stopPropagation();
    
    const filterContainer = event.target.parentElement.querySelector('.filter-list-values');
    if (filterContainer) {
      const filterListItems = filterContainer.querySelectorAll('.filter-list-item');
      filterListItems.forEach(function(item) {
        item.classList.remove('hidden-option');
      });
    }
  }
});

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.filter-list-values')) {
    setTimeout(initializeShowMoreFilters, 100);
  }
});

document.addEventListener('shopify:section:reorder', function(event) {
  setTimeout(initializeShowMoreFilters, 100);
});

document.addEventListener('shopify:section:select', function(event) {
  setTimeout(initializeShowMoreFilters, 100);
});

document.addEventListener('change', function(event) {
  if (event.target.closest('facet-filters-form')) {
    setTimeout(initializeShowMoreFilters, 500);
  }
});

document.addEventListener('facet:updated', function() {
  initializeShowMoreFilters();
});

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      for (let i = 0; i < mutation.addedNodes.length; i++) {
        const node = mutation.addedNodes[i];
        if (node.nodeType === 1 && node.querySelector && node.querySelector('.show-more-filters-button')) {
          setTimeout(initializeShowMoreFilters, 100);
          break;
        }
      }
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});